import { useSelector } from 'react-redux';
import { useId } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { SelectV2Field } from 'lib/iterable-hook-form/FormField/SelectV2Field';
import { FormField } from 'ui/formField';
import { FlexSpacer } from 'ui/flexSpacer';
import type { DefaultSenderEmailFormContextType } from '../contexts/DefaultSenderEmailFormProvider';
import { selectAuthedEmailsAsFormOptions } from '../selectors';
import type { DefaultSenderEmailFormProps } from '../types';

export const DefaultSenderEmailForm = ({ formId, onSubmit }: DefaultSenderEmailFormProps) => {
  const formFieldId = useId();
  const options = useSelector(selectAuthedEmailsAsFormOptions);

  const { handleSubmit } = useFormContext<DefaultSenderEmailFormContextType>();
  const { errors } = useFormState<DefaultSenderEmailFormContextType>();

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <FlexSpacer flexDirection="column" alignItems="stretch">
        <FormField
          data-test="authed-email-default-sender-email-select-form-field"
          errorText={errors.senderName?.message}
          hasError={!!errors.senderName?.message}
          inputId={formFieldId}
          labelText="Default sender email"
        >
          <SelectV2Field
            id={formFieldId}
            name="senderName"
            options={options}
            placeholder="Select a default sender email"
            usePortal
            valueType="string"
          />
        </FormField>
      </FlexSpacer>
    </form>
  );
};
